var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "MapPinIcon",
      "size": "30"
    }
  }), _vm._v(" Endereços dos Alunos ")], 1)]), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.fetchEnderecos.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Buscar por aluno, código, rua, bairro ou CEP"
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.filtro.search,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "search", $$v);
      },
      expression: "filtro.search"
    }
  })], 1)], 1)], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary button-right",
      "to": {
        name: 'AlunoEnderecoCadastrar'
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Novo Endereço ")], 1)], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Escola")]), _c('v-select', {
    attrs: {
      "options": _vm.escolaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todas as escolas"
    },
    on: {
      "input": _vm.onEscolaChange
    },
    model: {
      value: _vm.filtro.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "schoolId", $$v);
      },
      expression: "filtro.schoolId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Turma")]), _c('v-select', {
    attrs: {
      "options": _vm.turmaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todas as turmas",
      "disabled": !_vm.filtro.schoolId
    },
    on: {
      "input": _vm.fetchEnderecos
    },
    model: {
      value: _vm.filtro.classroomId,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "classroomId", $$v);
      },
      expression: "filtro.classroomId"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex align-items-end",
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.limparFiltros
    }
  }, [_vm._v(" Limpar Filtros ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchEnderecos
    }
  }, [_vm._v(" Filtrar ")])], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('div', {
    staticClass: "align-self-center text-muted"
  }, [_vm._v(" Total: "), _c('strong', [_vm._v(_vm._s(_vm.fetchedData.totalItems || 0))]), _vm._v(" endereço(s) ")]), _c('b-pagination', {
    staticClass: "ml-auto mb-0",
    attrs: {
      "total-rows": _vm.fetchedData.totalItems || 0,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1), _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refTable",
    staticClass: "position-relative",
    attrs: {
      "items": _vm.fetchedData.content,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "show-empty": "",
      "empty-text": "Nenhum endereço de aluno cadastrado."
    },
    scopedSlots: _vm._u([{
      key: "cell(nomeAluno)",
      fn: function fn(data) {
        return [_c('div', [_c('span', {
          staticClass: "font-weight-bolder text-primary d-block"
        }, [_vm._v(_vm._s(data.item.nomeAluno))]), data.item.nomeResponsavel ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" Resp: " + _vm._s(data.item.nomeResponsavel) + " ")]) : _vm._e()])];
      }
    }, {
      key: "cell(escolaNome)",
      fn: function fn(data) {
        return [_c('div', [_c('span', {
          staticClass: "d-block font-weight-bold"
        }, [_vm._v(_vm._s(data.item.escolaNome || 'Escola não informada'))]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.turmaNome || data.item.turmaTexto || 'Turma não informada'))])])];
      }
    }, {
      key: "cell(codigoDomicilio)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "font-weight-bold",
          attrs: {
            "variant": "light-primary"
          }
        }, [_vm._v(" " + _vm._s(data.item.codigoDomicilio || '-') + " ")])];
      }
    }, {
      key: "cell(endereco)",
      fn: function fn(data) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(data.item.endereco)), data.item.numero ? [_vm._v(", " + _vm._s(data.item.numero))] : _vm._e()], 2), data.item.complemento ? _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v("Comp: " + _vm._s(data.item.complemento))]) : _vm._e(), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" " + _vm._s(data.item.bairro)), data.item.municipio ? [_vm._v(" - " + _vm._s(data.item.municipio))] : _vm._e(), data.item.cep ? [_vm._v(" (" + _vm._s(data.item.cep) + ")")] : _vm._e()], 2), data.item.pontoReferencia ? _c('small', {
          staticClass: "d-block text-info"
        }, [_vm._v(" Ref: " + _vm._s(data.item.pontoReferencia) + " ")]) : _vm._e()])];
      }
    }, {
      key: "cell(telefone)",
      fn: function fn(data) {
        return [_c('span', [_vm._v(_vm._s(data.item.telefone || '-'))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": "",
            "right": _vm.$store.state.appConfig.isRTL
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'AlunoEnderecoEditar',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Editar")])], 1), _c('b-dropdown-item', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.confirmDelete(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Excluir")])], 1)], 1)];
      }
    }])
  })], 1), _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('b-pagination', {
    staticClass: "ml-auto",
    attrs: {
      "total-rows": _vm.fetchedData.totalItems || 0,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }